/**
 * @instance vaiMarker = {
 * 	info: html-string with marker-related information
 * 	marker : {
 * 		html: HTMLElement (span) = <span class="CLASSNAME" data-key="INDEX">MARKERCITY</span>
 * 		pos: array = position of the marker, related to map image -> [string leftposition, string topposition]
 * 	}
 * }
 */
class vaiMarker{
	constructor(raw,index){
		// set inital classname + destructure raw
		const markerClasses = ['marker','font-din-bold'];
		const {hervorheben,titelposition,name,kurzbeschreibung,bild,text,position} = raw;

		//1. check hightlight class for marker
		if(hervorheben)
			markerClasses.push('highlight');

		//2. Set position class for marker
		markerClasses.push(titelposition === 'right' ? 'right' : 'left');

		//3. Build marker-dom node
		const theMarker        = document.createElement('span');
		theMarker.className    = markerClasses.join(' ');
		theMarker.innerText    = name;
		theMarker.setAttribute('data-key',index);

		// 4. Build Position
		const positionArray = position.split(',');
		if(titelposition === 'left')
			positionArray[0] = (parseInt(positionArray[0]) - name.length*1.65)  + '%';

		//5. set props
		this.info = `<h2>${name}</h2><h3>${kurzbeschreibung}</h3>`;
		if(bild)
			this.info += `<img src="${bild}" alt="${name}" class="img-fluid">`;
		this.info += `<div>${text}</div>`;

		this.marker = {
			html: theMarker,
			pos: positionArray
		};
	}
}